export const PACKAGE_FIELD_TYPES = [
  { id: 'text', label: 'Text' },
  { id: 'number', label: 'Number' },
  { id: 'boolean', label: 'Yes / No' },
  { id: 'textarea', label: 'Long text' },
  { id: 'url', label: 'URL' },
  { id: 'currency', label: 'Currency' },
];

export function emptyPackageCustomField() {
  return { label: '', field_type: 'text', value: '', show_on_card: true };
}

export function emptyPackageEntitlement() {
  return {
    is_new: true,
    code: '',
    name: '',
    unit: 'minute',
    billing_mode: 'usage',
    unit_price: 0,
    quantity: 1,
    line_price: 0,
    pay_rate: 0,
    bill_rate: 0,
    gross_margin_pct: 0,
    gross_mode: 'pct',
    gross_amount: 0,
    burden_mode: 'pct',
    burden_value: 0,
    overhead_mode: 'pct',
    overhead_value: 0,
    notes: '',
    custom_label: '',
    _rateLock: null,
  };
}

export function formatPackageFieldValue(field) {
  if (!field) return '';
  if (field.field_type === 'boolean') {
    return field.value === '1' || field.value === 'true' || field.value === true ? 'Yes' : 'No';
  }
  return field.value || '';
}

/**
 * Build package form state from API detail.
 * Only includes entitlements that are on the package (blank packages stay blank).
 */
export function packageFormFromDetail(detail) {
  return {
    company_id: String(detail.company_id),
    name: detail.name || '',
    description: detail.description || '',
    package_price: detail.package_price ?? 0,
    consultant_hourly_rate: detail.consultant_pay_rate ?? detail.consultant_hourly_rate ?? 0,
    consultant_bill_rate: detail.consultant_bill_rate ?? 0,
    gross_margin_pct: detail.gross_margin_pct ?? 0,
    hire_bonus_amount: detail.hire_bonus_amount ?? 0,
    currency: detail.currency || 'USD',
    service_duration: detail.service_duration ?? '',
    service_duration_unit: detail.service_duration_unit || 'minute',
    duration_period: detail.duration_period ?? '',
    duration_period_unit: detail.duration_period_unit || 'month',
    items: (detail.items || []).map((i) => {
      const bill = Number(i.bill_rate) || Number(i.unit_price) || 0;
      // Preserve explicit 0% gross — do not treat as "missing"
      const hasMargin =
        i.gross_margin_pct != null && i.gross_margin_pct !== '';
      const margin = hasMargin ? Number(i.gross_margin_pct) || 0 : null;
      let pay = Number(i.pay_rate) || 0;
      // Prefer stored employee pay; only derive from margin when pay is missing
      if (!(pay > 0) && bill > 0 && hasMargin) {
        pay = Math.round(bill * (1 - margin / 100) * 100) / 100;
      }
      return {
        catalog_item_id: i.catalog_item_id,
        is_new: false,
        code: i.code || '',
        name: i.custom_label || i.catalog_name || i.name || '',
        unit: i.unit || 'unit',
        unit_price: bill,
        billing_mode: i.billing_mode || 'usage',
        quantity: i.quantity ?? 1,
        line_price: i.total_bill ?? i.line_price ?? 0,
        pay_rate: pay,
        bill_rate: bill,
        gross_margin_pct: hasMargin
          ? margin
          : bill > 0 && pay >= 0
            ? Math.round(((bill - pay) / bill) * 10000) / 100
            : Number(i.gross_margin_pct) || 0,
        gross_mode: 'pct',
        gross_amount: bill > 0 && pay >= 0 ? Math.round((bill - pay) * 100) / 100 : 0,
        burden_mode: i.burden_mode === 'amount' ? 'amount' : 'pct',
        burden_value: i.burden_value ?? 0,
        overhead_mode: i.overhead_mode === 'amount' ? 'amount' : 'pct',
        overhead_value: i.overhead_value ?? 0,
        notes: i.notes || '',
        custom_label: i.custom_label || '',
        _rateLock: 'pay',
      };
    }),
    custom_fields: (detail.custom_fields || []).map((f) => ({
      label: f.label,
      field_type: f.field_type || 'text',
      value: f.value || '',
      show_on_card: f.show_on_card !== 0,
    })),
  };
}
